<template>
  <ui-checkbox
    v-for="option in checklist"
    :key="option.value"
    class="emh-ui-checkbox-list"
    v-bind="option"
    @change="handleChange(option)"
  ></ui-checkbox>
  <button
    v-if="total > maxItems"
    class="emh-ui-checkbox-list__button"
    data-test-id="emh-ui-checkbox-list__button"
    @click.prevent="handleExpand"
  >
    {{ expanded ? $t('ui.form.checkbox.showLess') : $t('ui.form.checkbox.showMore', { total: total - maxItems }) }}
  </button>
</template>

<script lang="ts">
import UiCheckbox from '../Checkbox.vue';

export default {
  name: 'UICheckboxList',
  components: {
    UiCheckbox,
  },
};
</script>

<script lang="ts" setup>
import { computed, PropType, ref, toRefs } from 'vue';
import { CheckBoxProps } from '../checkbox.model';

const props = defineProps({
  name: { type: String, default: '' },
  title: { type: String, default: '' },
  options: { type: Array as PropType<CheckBoxProps[]>, required: true },
  maxItems: { type: Number, default: 7 },
});

const emit = defineEmits(['change']);

const { options, maxItems } = toRefs(props);

const expanded = ref<boolean>(false);
const total = computed<number>(() => options.value.length);
const checklist = computed<CheckBoxProps[]>(() =>
  expanded.value ? options.value : options.value.slice(0, maxItems.value),
);

const handleChange = (option: CheckBoxProps) => {
  emit('change', option);
};

const handleExpand = () => {
  expanded.value = !expanded.value;
};
</script>

<style lang="scss" scoped>
.emh-ui-checkbox-list {
  @include wb-spacing('margin-bottom', 'xs');

  &__button {
    @include wb-link;
    @include wb-link--inline;
    @include wb-type-button;

    border-color: var(--wb-blue-45);
    border-top: none;
    border-left: none;
    border-right: none;
    color: var(--wb-blue-45);
  }
}
</style>
